window.luiReferenceControllers = window.luiReferenceControllers || [];
window.luiReferenceControllers.push(function (application, Stimulus) {
    application.register("comp_references_single_siemens", class extends Stimulus.Controller {
    get target() {
        return {
            pressLightDark: this.targets.find("pressLightDark"),
            anniversaryVisual:  this.targets.find("anniversaryVisual")
        }
    }

    async connect() {
        let self = this;
        this._gsapTweens = [];
        await importScript([cdnjs.gsap, cdnjs.gsapScrollTrigger]);
        gsap.registerPlugin(ScrollTrigger);

        let tlPressLightDark = gsap.timeline({
            scrollTrigger: {
                trigger: self.target.pressLightDark,
                scrub: true,
                pin: false,
                start: "top-100 center",
                end: "top+200"
            }
        });

        this._gsapTweens.push(tlPressLightDark);

        tlPressLightDark.fromTo(self.target.pressLightDark.querySelector('[data-ref="pressDark"]'),
            {
                opacity: 0,
                ease: "ease",
            },
            {
                opacity: 1,
                ease: "ease",
            });

        let tlAnniversaryVisual = gsap.timeline({
            scrollTrigger: {
                trigger: self.target.anniversaryVisual,
                scrub: true,
                pin: false,
                start: "top bottom-=200px",
                end: "bottom bottom"
            }
        });

        this._gsapTweens.push(tlAnniversaryVisual);

        tlAnniversaryVisual
            .from(self.target.anniversaryVisual.querySelector('[data-ref="visualFamily"]'),
                {
                    scale: 2,
                    ease: "linear"
                })
            .from(self.target.anniversaryVisual.querySelector('[data-ref="visualBoy"]'),
                {
                    scale: 2,
                    ease: "linear",
                })
    }

    disconnect() {
        if (!this._gsapTweens) {
            return
        }

        this._gsapTweens.forEach((tween) => {
            if (tween.scrollTrigger) {
                tween.scrollTrigger.kill()
            }

            tween.kill()
        })

        this._gsapTweens = []
    }
});
});
window.luiRegisterReferenceControllers && window.luiRegisterReferenceControllers();
